import React from "react";
import OrganizationDashboardContainer from "../../modules/OrganizationDashboard/containers/OrganizationDashboardContainer/OrganizationDashboardContainer";

const OrganizationDashboard = () => {
  return <OrganizationDashboardContainer />;
};

export default OrganizationDashboard;
